import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const avgClicksPerPinConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.pinterest.avg_clicks_per_pin',
    id: 'average_clicks_per_pin',
    icon: {
        name: 'click',
        style: colors.blue
    },
    tooltip: 'kpi.pinterest.tooltip_avg_clicks_per_pin',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
